@if (registration) {
  @if (expireuser) {
    <div class="container row justify-content-center">
      {{ '$link_deactivated_contact_administrator_label$' | translate }}
    </div>
  }
  @if (!expireuser) {
    <div class="container">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-md-8 col-xl-8">
            <div class="text-center">
              <a href="/">
                <img src="/assets/img/logo.png" alt="" width="132" />
              </a>
              <br />
              <br />
              <p>{{ '$enter_additional_information_label$' | translate }}</p>
            </div>
            <div class="card">
              <div class="card-body">
                <form novalidate id="registration-form" [formGroup]="rdgform" (ngSubmit)="registerUser(rdgform)">
                  <div class="row justify-content-center">
                    <div class="col-auto">
                      <div class="select-avatar py-3">
                        <div class="avatar-handler mx-auto">
                          <div
                            class="avatar-preview"
                            [ngStyle]="{ 'background-image': 'url(' + displayImage + ')' }"></div>
                        </div>
                        <strong class="btn btn-primary btn-capsule upload-doc-btn mt-3">
                          {{ '$label_choose_file$' | translate }}
                          <input
                            #avatarUrl
                            class="upload-doc-input"
                            type="file"
                            id="avatarUrl"
                            accept="image/*"
                            (change)="upload(avatarUrl.files)" />
                        </strong>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="firstname"
                          >{{ '$field_firstname$' | translate }}<strong class="required-field-asterisk">*</strong>
                        </label>
                        <input
                          #firstName
                          type="text"
                          class="form-control"
                          id="firstName"
                          formControlName="firstName"
                          [placeholder]="'$first_name_placeholder$' | translate"
                          [ngClass]="{ 'has-error': rdgform.controls['firstName'].invalid && validate }" />
                        @if (rdgform.controls['firstName'].invalid && validate) {
                          <div>
                            @if (rdgform.controls['firstName'].errors.maxlength) {
                              <div>
                                <p class="validation-message">{{ '$field_error_firstName_maxlength$' | translate }}</p>
                              </div>
                            }
                            @if (
                              rdgform.controls['firstName'].errors.required ||
                              rdgform.controls['firstName'].errors.whitespace
                            ) {
                              <div>
                                <p class="validation-message">{{ '$field_error_firstName_required$' | translate }}</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="lastName"
                          >{{ '$field_lastname$' | translate }}<strong class="required-field-asterisk">*</strong>
                        </label>
                        <input
                          #lastName
                          type="text"
                          class="form-control"
                          id="lastname"
                          formControlName="lastName"
                          [placeholder]="'$last_name_placeholder$' | translate"
                          [ngClass]="{ 'has-error': rdgform.controls['lastName'].invalid && validate }" />
                        @if (rdgform.controls['lastName'].invalid && validate) {
                          <div>
                            @if (rdgform.controls['lastName'].errors.maxlength) {
                              <div>
                                <p class="validation-message">{{ '$field_error_lastName_maxlength$' | translate }}</p>
                              </div>
                            }
                            @if (
                              rdgform.controls['lastName'].errors.required ||
                              rdgform.controls['lastName'].errors.whitespace
                            ) {
                              <div>
                                <p class="validation-message">{{ '$field_error_lastName_required$' | translate }}</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="email"
                          >{{ '$field_email$' | translate }}<strong class="required-field-asterisk">*</strong>
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          formControlName="email"
                          [placeholder]="'$email_placeholder$' | translate"
                          [disabled]="true"
                          [ngClass]="{ 'has-error': rdgform.controls['email'].invalid && validate }" />
                        @if (rdgform.controls['email'].invalid && validate) {
                          <div>
                            @if (rdgform.controls['email'].errors.required) {
                              <div>
                                <p class="validation-message">{{ '$field_error_email_required$' | translate }}</p>
                              </div>
                            }
                            @if (rdgform.controls['email'].errors.pattern) {
                              <div>
                                <p class="validation-message">{{ '$field_error_email_pattern$' | translate }}</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="phone">{{ '$field_phone$' | translate }}</label>
                        <input
                          type="text"
                          class="form-control"
                          id="phone"
                          formControlName="phone"
                          [placeholder]="'$phone_placeholder$' | translate" />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="password"
                          >{{ '$field_password$' | translate }}<strong class="required-field-asterisk">*</strong>
                        </label>
                        <input
                          #password
                          type="password"
                          class="form-control"
                          id="password"
                          formControlName="password"
                          [placeholder]="'$label_password$' | translate"
                          [ngClass]="{ 'has-error': rdgform.controls['password'].invalid && validate }" />
                        @if (rdgform.controls['password'].invalid && validate) {
                          <div>
                            @if (rdgform.controls['password'].errors.maxlength) {
                              <div>
                                <p class="validation-message">{{ '$field_error_password_maxlength$' | translate }}</p>
                              </div>
                            }
                            @if (
                              rdgform.controls['password'].errors.required ||
                              rdgform.controls['password'].errors.whitespace
                            ) {
                              <div>
                                <p class="validation-message">{{ '$field_error_password_required$' | translate }}</p>
                              </div>
                            }
                            @if (rdgform.controls['password'].errors.pattern) {
                              <div>
                                <p class="validation-message">{{ '$field_error_password_pattern$' | translate }}</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="confirmPassword"
                          >{{ '$field_confirmPassword$' | translate }}<strong class="required-field-asterisk">*</strong>
                        </label>
                        <input
                          #confirmPassword
                          type="password"
                          class="form-control"
                          id="confirmPassword"
                          formControlName="confirmPassword"
                          compare="password"
                          [placeholder]="'$field_confirmPassword$' | translate"
                          [ngClass]="{ 'has-error': rdgform.controls['confirmPassword'].invalid && validate }" />
                        @if (
                          rdgform.controls['confirmPassword'].invalid &&
                          validate &&
                          (rdgform.controls['confirmPassword'].dirty || rdgform.controls['confirmPassword'].touched)
                        ) {
                          <div>
                            @if (rdgform.controls['confirmPassword'].errors.required) {
                              <div>
                                <p class="validation-message">
                                  {{ '$field_error_confirmPassword_required$' | translate }}
                                </p>
                              </div>
                            }
                            @if (rdgform.controls['confirmPassword'].hasError('notSame')) {
                              <div>
                                <p class="validation-message">
                                  {{ '$field_password_confirmPassword_notMatched$' | translate }}
                                </p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="form-group">
                        <label for="languageCode"
                          >{{ '$field_language$' | translate }}
                          <strong class="required-field-asterisk">*</strong></label
                        >
                        <app-language-select formControlName="languageCode" />
                        @if (rdgform.controls['languageCode'].invalid && validate) {
                          <div>
                            @if (rdgform.controls['languageCode'].errors.required) {
                              <div>
                                <div class="validation-message">
                                  {{ '$field_error_languageCode_required$' | translate }}
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="form-group buttons text-right">
                    <button type="submit" form="registration-form" class="btn btn-primary btn-capsule">
                      {{ '$button_saveandcontinue$' | translate }}<i class="material-icons mi-inline">check</i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
